/**
 * @typedef {Object} ReturnExchangeWarrantyPageDataProductSize
 * @property {string} sref1
 * @property {string} sref2
 * @property {number} qtyAvailable
 */

/**
 * @typedef {Object} ReturnExchangeWarrantyPageDataProduct
 * @property {string} handle
 * @property {string} url
 * @property {string} mainImgUrl
 * @property {string} mainImgAlt
 * @property {Date} discontinuedDate
 * @property {ReturnExchangeWarrantyPageDataProductSize[]} sizes
 */

/**
 * @typedef {Object} ReturnExchangeWarrantyPageData
 * @property {number | undefined} userId
 * @property {string | undefined} userEmail
 * @property {string | undefined} encryptedVerification
 * @property {string} baseCdnPath
 * @property {string} baseCdnPathFallback
 * @property {ReturnExchangeWarrantyPageDataProduct[]} allValidProducts
 */

/**
 * A single physical unit of an ordered article.
 *
 * The API groups articles by mouvementNb and exposes quantities instead of one
 * entry per unit (see separateOrderArticles), but the UI still shows one row per
 * unit. Each unit therefore carries a synthetic `uid` (used to identify the
 * selected row now that there is no per-unit number) and flags telling whether
 * it's already used up by a completed or in-progress request.
 * @typedef {DivZeroWebPublicModels.CustomerShippedOrderArticle & {
 *   uid?: string,
 *   returned?: boolean,
 *   exchanged?: boolean,
 *   warrantied?: boolean
 * }} ReturnExchangeWarrantyOrderUnit
 */

/**
 * A shipped order whose grouped articles have been expanded into individual
 * units (see separateOrderArticles).
 * @typedef {Omit<DivZeroWebPublicModels.CustomerShippedOrder, "items"> & {
 *   items?: ReturnExchangeWarrantyOrderUnit[]
 * }} ReturnExchangeWarrantyOrder
 */

const returnExchangeWrarrantyPageData = /** @type {ReturnExchangeWarrantyPageData} */ (
    JSON.parse(
        document.getElementById("return-exchange-wrarranty-page-data")?.textContent ?? "{}"
    )
);
//Mapping the date strings to Date objects
returnExchangeWrarrantyPageData.allValidProducts?.forEach(p => {
    if (!p.discontinuedDate) return;
    const [y, m, d] = String(p.discontinuedDate).split("-").map(Number);
    p.discontinuedDate = new Date(y, m - 1, d);
});

//Disable all article box for now
Array.from(document.querySelectorAll(".articleBox")).forEach(articleBox => {
    if (!articleBox.classList.contains("alwaysShow")) articleBox.classList.add("d-none");
});

/** @param {string} selector */
const cloneTemplate = (selector) => {
    const el = templatesWrapper.querySelector(selector);
    if (!el) throw new Error(`Template not found: ${selector}`);
    return el.cloneNode(true);
};

const lowStockTreshold = 5;

const templatesWrapper = /** @type {HTMLElement} */ (document.getElementById("templatesWrapper"));

const introSlide = /** @type {HTMLElement} */ (document.getElementById("introSlide"));
const orderSelectionSlide = /** @type {HTMLElement} */ (document.getElementById("orderSelectionSlide"));
const typeSelectionSlide = /** @type {HTMLElement} */ (document.getElementById("typeSelectionSlide"));
const wrongArticleQuestionSlide = /** @type {HTMLElement} */ (document.getElementById("wrongArticleQuestionSlide"));
const articleSelectionSlide = /** @type {HTMLElement} */ (document.getElementById("articleSelectionSlide"));
const returnQuestionOneSlide = /** @type {HTMLElement} */ (document.getElementById("returnQuestionOneSlide"));
const returnQuestionTwoSlide = /** @type {HTMLElement} */ (document.getElementById("returnQuestionTwoSlide"));
const returnQuestionThreeSlide = /** @type {HTMLElement} */ (document.getElementById("returnQuestionThreeSlide"));
const returnQuestionThreeOtherSlide = /** @type {HTMLElement} */ (document.getElementById("returnQuestionThreeOtherSlide"));
const warrantyQuestionOneSlide = /** @type {HTMLElement} */ (document.getElementById("warrantyQuestionOneSlide"));
const exchangeSizeSelectionSlide = /** @type {HTMLElement} */ (document.getElementById("exchangeSizeSelectionSlide"));
const wrongBootsSizeSelectionSlide = /** @type {HTMLElement} */ (document.getElementById("wrongBootsSizeSelectionSlide"));
const wrongBootsShouldReceiveSlide = /** @type {HTMLElement} */ (document.getElementById("wrongBootsShouldReceiveSlide"));
const customerInformationSlide = /** @type {HTMLElement} */ (document.getElementById("customerInformationSlide"));
const imagesSlide = /** @type {HTMLElement} */ (document.getElementById("imagesSlide"));
const finalCheckSlide = /** @type {HTMLElement} */ (document.getElementById("finalCheckSlide"));
const requestCreatedSlide = /** @type {HTMLElement} */ (document.getElementById("requestCreatedSlide"));
const requestFailedSlide = /** @type {HTMLElement} */ (document.getElementById("requestFailedSlide"));

const yourModelTitleClass = "YourModelText";
const newModelTitleClass = "YourRequestedModelText";
const selectedClassName = "selectedReturnRow";

const graceDays = 14;
const maxDaysReturnExchange = 60 + graceDays;
const maxDaysWarranty = 182.5 + graceDays;

const maxDaysReturnExchangeDiscontinued = 0;
const maxDaysWarrantyDiscontinued = 30 + graceDays;

const divSteps = document.getElementsByClassName("divSteps");

const emailInput = /** @type {HTMLInputElement} */ (document.getElementById("emailInput"));
const orderIdInput = /** @type {HTMLInputElement} */ (document.getElementById("orderIdInput"));
const orderIdSelect = /** @type {HTMLSelectElement} */ (document.getElementById("orderIdSelect"));
const orderIdElement = /** @type {HTMLInputElement} */ (document.getElementById("orderIdElement"));
const submitOrderChoiceBtn = /** @type {HTMLButtonElement | null} */ (document.getElementById("submitOrderChoiceBtn"));

const invalidStartInfoP = document.getElementById("invalidStartInfoP");

const orderNumberSpan = /** @type {HTMLElement[]} */ (Array.from(document.querySelectorAll(".orderNumberSpan")));
const orderDateSpan = /** @type {HTMLElement[]} */ (Array.from(document.querySelectorAll(".orderDateSpan")));

const articleSelectionTitlesWrapper = /** @type {HTMLElement} */ (document.getElementById("articleSelectionTitlesWrapper"));
const returnInArticleWrapper = /** @type {HTMLElement} */ (document.getElementById("returnInArticleWrapper"));

const typeSelectWrapper = /** @type {HTMLElement} */ (document.getElementById("typeSelectWrapper"));
let returnType = "";
/** @type { string | null} */
let returnReason = null;
/** @type { string | null} */
let returnReasonDescription = null;

const returnTypeArticleBox = /** @type {HTMLElement} */ (document.getElementById("returnTypeArticleBox"));
const returnQuestionOneArticleBox = /** @type {HTMLElement} */ (document.getElementById("returnQuestionOneArticleBox"));
const returnQuestionTwoArticleBox = /** @type {HTMLElement} */ (document.getElementById("returnQuestionTwoArticleBox"));
const returnQuestionThreeArticleBox = /** @type {HTMLElement} */ (document.getElementById("returnQuestionThreeArticleBox"));
const returnQuestionThreeOtherArticleBox = /** @type {HTMLElement} */ (document.getElementById("returnQuestionThreeOtherArticleBox"));
const warrantyQuestionOneArticleBox = /** @type {HTMLElement} */ (document.getElementById("warrantyQuestionOneArticleBox"));
const imageArticleBox = /** @type {HTMLElement} */ (document.getElementById("imageArticleBox"));

const returnQuestionThreeWrapper = /** @type {HTMLElement} */ (document.getElementById("returnQuestionThreeWrapper"));
const returnQuestionThreeOtherTitle = /** @type {HTMLElement} */ (document.getElementById("returnQuestionThreeOtherTitle"));
const returnReasonOtherInput = /** @type {HTMLTextAreaElement} */ (document.getElementById("otherReturnReason"));

const boArtExchangeModelSelectionArticleBox = /** @type {HTMLElement} */ (document.getElementById("boArtExchangeModelSelectionArticleBox"));
const boArtNewModelSelectWrapper = /** @type {HTMLElement} */ (document.getElementById("boArtNewModelSelectWrapper"));
const boArtNewModelSelect = /** @type {HTMLSelectElement} */ (document.getElementById("boArtNewModelSelect"));

const exchangeModelSelectionArticleBox = /** @type {HTMLElement} */ (document.getElementById("exchangeModelSelectionArticleBox"));
const newModelSelectWrapper = /** @type {HTMLElement} */ (document.getElementById("newModelSelectWrapper"));
const newModelSelect = /** @type {HTMLSelectElement} */ (document.getElementById("newModelSelect"));

const exchangeModelReasonArticleBox = /** @type {HTMLElement} */ (document.getElementById("exchangeModelReasonArticleBox"));

const exchangeSizeSelectionArticleBox = /** @type {HTMLElement} */ (document.getElementById("exchangeSizeSelectionArticleBox"));
const exchangeSizeSelectionSection = /** @type {HTMLElement} */ (document.getElementById("exchangeSizeSelectionSection"));
const exchangeSizeSelection = /** @type {HTMLElement} */ (document.getElementById("exchangeSizeSelection"));
const exchangeWidthSelectionSection = /** @type {HTMLElement} */ (document.getElementById("exchangeWidthSelectionSection"));
const exchangeWidthSelection = /** @type {HTMLElement} */ (document.getElementById("exchangeWidthSelection"));

const wrongBootsSizeSelectionArticleBox = /** @type {HTMLElement} */ (document.getElementById("wrongBootsSizeSelectionArticleBox"));
const wrongRefInput = /** @type {HTMLInputElement} */ (document.getElementById("wrongRefInput"));
const wrongRefDatalist = /** @type {HTMLDataListElement} */ (document.getElementById("wrongRefDatalist"));
const wrongBootsSizeSelectionSection = /** @type {HTMLElement} */ (document.getElementById("wrongBootsSizeSelectionSection"));
const wrongBootsSizeSelection = /** @type {HTMLElement} */ (document.getElementById("wrongBootsSizeSelection"));
const wrongBootsWidthSelectionSection = /** @type {HTMLElement} */ (document.getElementById("wrongBootsWidthSelectionSection"));
const wrongBootsWidthSelection = /** @type {HTMLElement} */ (document.getElementById("wrongBootsWidthSelection"));
const wrongBootShouldReceiveArticles = /** @type {HTMLElement} */ (document.getElementById("wrongBootShouldReceiveArticles"));

const defectDescriptionWrapper = /** @type {HTMLElement} */ (document.getElementById("defectDescriptionWrapper"));
const defectDescriptionTitle = /** @type {HTMLElement} */ (document.getElementById("defectDescriptionTitle"));
const defectDescriptionInput = /** @type {HTMLTextAreaElement} */ (document.getElementById("defectDescriptionInput"));
const imageElements = /** @type {HTMLImageElement[]} */ (Array.from(document.querySelectorAll(".productImage")));
const imageInputs = /** @type {HTMLInputElement[]} */ (Array.from(document.querySelectorAll(".imageInput")));
const imageTitles =/** @type {HTMLElement[]} */ (Array.from(document.querySelectorAll(".imageTitle")));

const finalCheckRequestType = /** @type {HTMLElement} */ (document.getElementById("finalCheckRequestType"));
const finalCheckLowOnStockWarning = /** @type {HTMLElement} */ (document.getElementById("finalCheckLowOnStockWarning"));
const finalCheckOutOfStockWarning = /** @type {HTMLElement} */ (document.getElementById("finalCheckOutOfStockWarning"));
const finalCheckReturnIn = /** @type {HTMLElement} */ (document.getElementById("finalCheckReturnIn"));
const finalCheckReturnOutArrow = /** @type {HTMLElement} */ (document.getElementById("finalCheckReturnOutArrow"));
const finalCheckReturnOut = /** @type {HTMLElement} */ (document.getElementById("finalCheckReturnOut"));
const finalCheckReasonWrapper = /** @type {HTMLElement} */ (document.getElementById("finalCheckReasonWrapper"));
const finalCheckReason = /** @type {HTMLElement} */ (document.getElementById("finalCheckReason"));
const finalCheckShippingAddressWrapper = /** @type {HTMLElement} */ (document.getElementById("finalCheckShippingAddressWrapper"));

const finalCheckImagesWrapper = /** @type {HTMLElement} */ (document.getElementById("finalCheckImagesWrapper"));
const finalCheckImages = /** @type {HTMLElement} */ (document.getElementById("finalCheckImages"));
const agreeTermsCheckboxInput = /** @type {HTMLInputElement} */ (document.getElementById("agreeTermsCheckboxInput"));

const shippingAddressInfoWrapper = /** @type {HTMLElement} */ (document.getElementById("shippingAddressInfoWrapper"));
const finalCheckShippingFName = /** @type {HTMLElement} */ (document.getElementById("finalCheckShippingFName"));
const finalCheckShippingLName = /** @type {HTMLElement} */ (document.getElementById("finalCheckShippingLName"));
const finalCheckShippingCompanyWrapper = /** @type {HTMLElement} */ (document.getElementById("finalCheckShippingCompanyWrapper"));
const finalCheckShippingCompany = /** @type {HTMLElement} */ (document.getElementById("finalCheckShippingCompany"));
const finalCheckShippingAddress = /** @type {HTMLElement} */ (document.getElementById("finalCheckShippingAddress"));
const finalCheckShippingLoc = /** @type {HTMLElement} */ (document.getElementById("finalCheckShippingLoc"));
const finalCheckShippingLocWrapper = /** @type {HTMLElement} */ (document.getElementById("finalCheckShippingLocWrapper"));
const finalCheckShippingCity = /** @type {HTMLElement} */ (document.getElementById("finalCheckShippingCity"));
const finalCheckShippingState = /** @type {HTMLElement} */ (document.getElementById("finalCheckShippingState"));
const finalCheckShippingCPostal = /** @type {HTMLElement} */ (document.getElementById("finalCheckShippingCPostal"));
const finalCheckShippingPhone = /** @type {HTMLElement} */ (document.getElementById("finalCheckShippingPhone"));
const finalCheckShippingPhoneWrapper = /** @type {HTMLElement} */ (document.getElementById("finalCheckShippingPhoneWrapper"));

const editShippingAddressBtn = /** @type {HTMLButtonElement} */ (document.getElementById("editShippingAddressBtn"));

const shippingAddressEditWrapper = /** @type {HTMLElement} */ (document.getElementById("shippingAddressEditWrapper"));
const shippingAddressEditFName = /** @type {HTMLInputElement} */ (document.getElementById("shippingAddressEditFName"));
const shippingAddressEditLName = /** @type {HTMLInputElement} */ (document.getElementById("shippingAddressEditLName"));
const shippingAddressEditCompany = /** @type {HTMLInputElement} */ (document.getElementById("shippingAddressEditCompany"));
const shippingAddressEditAddress = /** @type {HTMLInputElement} */ (document.getElementById("shippingAddressEditAddress"));
const shippingAddressEditLoc = /** @type {HTMLInputElement} */ (document.getElementById("shippingAddressEditLoc"));
const shippingAddressEditCity = /** @type {HTMLInputElement} */ (document.getElementById("shippingAddressEditCity"));
const shippingAddressEditState = /** @type {HTMLSelectElement} */ (document.getElementById("shippingAddressEditState"));
const shippingAddressEditCPostal = /** @type {HTMLInputElement} */ (document.getElementById("shippingAddressEditCPostal"));
const shippingAddressEditPhone = /** @type {HTMLInputElement} */ (document.getElementById("shippingAddressEditPhone"));

const saveShippingAddressEditBtn = /** @type {HTMLButtonElement} */ (document.getElementById("saveShippingAddressEditBtn"));

const requestTypeConfirmation = /** @type {HTMLElement} */ (document.getElementById("requestTypeConfirmation"));

const requestCreatedEmailP = /** @type {HTMLElement} */ (document.getElementById("requestCreatedEmailP"));

let nbOfSlides = 0;
/** @type {ReturnExchangeWarrantyOrder | null} */
let selectedOrder = null;
/** @type {HTMLElement | null} */
let crtSelectedRow = null;
/** @type {ReturnExchangeWarrantyOrderUnit | null} */
let selectedItemIn = null;
/** @type {HTMLButtonElement | null} */
let returnInSelectedSref1 = null;
/** @type {HTMLButtonElement | null} */
let returnInSelectedSref2 = null;

/** @type {ReturnExchangeWarrantyOrderUnit | null} */
let selectedItemOut = null;
/** @type {HTMLButtonElement | null} */
let returnOutSelectedSref1 = null;
/** @type {HTMLButtonElement | null} */
let returnOutSelectedSref2 = null;

/** @type {ReturnExchangeWarrantyOrderUnit | null} */
let selectedWrongItem = null;
/** @type {HTMLButtonElement | null} */
let wrongBootsSelectedSref1 = null;
/** @type {HTMLButtonElement | null} */
let wrongBootsSelectedSref2 = null;

const swiperPrevBtnClass = "swiper-button-prev"
const swiperNextBtnClass = "swiper-button-next"

const returnExchangeWarrantyNextBtn = /** @type {HTMLButtonElement} */ (document.getElementById("nextBtn"));
const returnExchangeWarrantySendBtn = /** @type {HTMLButtonElement} */ (document.getElementById("sendBtn"));

/** @type {ReturnExchangeWarrantyOrder[]} */
let orders = [];

const returnExchangeWarrantyWebReturnRequestApi = getDivZeroWebPublicApi(DivZeroWebPublicApi.WebReturnRequestApi, false);
const returnExchangeWarrantyWebOrderApi = getDivZeroWebPublicApi(DivZeroWebPublicApi.WebOrderApi, false);

if (returnExchangeWrarrantyPageData.userId && returnExchangeWrarrantyPageData.encryptedVerification) {
    //Show loader
    siteLoader.show();

    document.addEventListener("DOMContentLoaded", async () => {

        try {
            let response = await returnExchangeWarrantyWebOrderApi.webOrderGetCustomerShippedOrdersByWebsiteCustomerId({
                websiteId: siteId,
                websiteCustomerId: returnExchangeWrarrantyPageData.userId,
                encryptedVerification: returnExchangeWrarrantyPageData.encryptedVerification,
                pageNb: 0,
                pageSize: 20
            });
            //Articles come grouped by mouvementNb; expand them into one unit per row for the UI
            orders = (response.items ?? []).map(separateOrderArticles);
            orders.forEach(order => {
                let option = document.createElement("option");
                option.classList.add("fw-bold");
                option.value = order.websiteOrderId?.toString() ?? "";
                option.innerHTML = order.websiteOrderId + " (" + order.placedOn?.toLocaleDateString('en-CA') + ")";
                orderIdSelect.appendChild(option);
            });
        }
        catch (error) {
            console.log(error);
            allowNextSlideBtn(true);
            swiperReturn.slideTo(getIndexOfChild(requestFailedSlide));
            swiperNextBtnEl?.classList.remove("swiperBtn");
            swiperPrevBtnEl?.classList.remove("swiperBtn");
            siteLoader.hide();
        }

        siteLoader.hide();
    });
}


returnExchangeWarrantySendBtn.addEventListener("click", post)

returnExchangeWrarrantyPageData.allValidProducts.forEach(article => {
    const option = document.createElement("option");
    option.innerText = article.handle.toUpperCase();
    wrongRefDatalist.appendChild(option);
});

/** @type {number | null} */
let timer = null;

let swiperReturn = new Swiper(".swiper-returns", {
    // Optional parameters
    direction: "horizontal",
    shortSwipes: false,
    simulateTouch: false,
    slideToClickedSlide: false,
    loop: false,
    speed: 200,
    autoHeight: true,
    allowSlideNext: false,
    allowTouchMove: false,
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    //allowSlidePrev: false,
    //allowTouchMove: false,
    // Navigation arrows
    navigation: {
        nextEl: "." + swiperNextBtnClass,
        prevEl: "." + swiperPrevBtnClass,
    },
    on: {
        slideChange: (swiper) => slideChange(swiper),
        beforeInit: () => { nbOfSlides = document.querySelector(".swiper-returns")?.querySelectorAll(".swiper-slide").length ?? 0; },
        slideChangeTransitionStart: (swiper) => slideChangeTransitionStart(swiper),
        slideChangeTransitionEnd: (swiper) => slideChangeTransitionEnd(swiper)
    },
});

const swiperEl = swiperReturn.el;
const swiperPrevBtnEl = /** @type {HTMLButtonElement}*/ (swiperEl.querySelector("." + swiperPrevBtnClass));
const swiperNextBtnEl = /** @type {HTMLButtonElement}*/ (swiperEl.querySelector("." + swiperNextBtnClass));

window.addEventListener("focus", () => {
    timer = performance.now()
});

Array.from(/** @type {HTMLCollectionOf<HTMLButtonElement>}*/(document.getElementsByClassName("finalCheckEditBtn"))).forEach(btn => {
    if (!btn.classList.contains("noSlideChange")) {
        btn.addEventListener("click", () => {
            let slideEl = document.getElementById(btn.dataset.slideId ?? "-_-");
            if (!slideEl) {
                if (returnType == "R" || returnType == "R-W") {
                    slideEl = returnQuestionTwoSlide
                }
                else if (returnType == "W") {
                    slideEl = warrantyQuestionOneSlide
                }
            }
            if (!slideEl) console.log("No slide with the id '" + btn.dataset.slideId + "' was found")
            else {
                swiperReturn.slideTo(getIndexOfChild(slideEl));
            }
        })
    }
});

agreeTermsCheckboxInput.addEventListener("change", () => {
    returnExchangeWarrantySendBtn.disabled = !agreeTermsCheckboxInput.checked;
});

/**
 * 
 * @param {File} file 
 * @returns 
 */
function toBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    })
}

async function post() {
    //show the loader
    siteLoader.show();

    //R = Return (send back for refund), E = Exchange, W = Warranty. The "-W" suffix (wrong article
    //received) is dropped here like the old code did; the wrong article travels in the item's
    //left/rightWrongArticle instead.
    /** @type {Record<string, number>} */
    const initialTypeByReturnType = { R: 0, E: 2, W: 4 };
    const baseType = returnType.endsWith("-W") ? returnType.slice(0, -2) : returnType;
    const initialType = initialTypeByReturnType[baseType];

    //The DOM image inputs are tagged with our own names; map them to WebReturnRequestImgTypeEnum
    //(RightSide = 0, LeftSide = 1, Sole = 2, Top = 3, Other = 4).
    /** @type {Record<string, number>} */
    const imageTypeByDataType = { RIGHT_SIDE: 0, LEFT_SIDE: 1, SOLE: 2, TOP: 3 };

    //Images are sent as the raw files (multipart IFormFile), with a parallel ImageInputs list
    //describing each one. The two are matched by position (and by fileName server side).
    /** @type {Blob[]} */
    const requestImages = [];
    /** @type {object[]} */
    const imageInputObjects = [];
    imageInputs.forEach(imgInput => {
        const file = imgInput.files?.[0];
        if (!file) return;
        requestImages.push(file);
        imageInputObjects.push({
            fileName: file.name,
            imageType: imageTypeByDataType[imgInput.dataset.type ?? ""] ?? 4, //4 = Other
            reasonAdded: null
        });
    });

    //If the customer received the wrong article, record what they actually got on both boots
    const wrongArticle = selectedWrongItem
        ? { ref: selectedWrongItem.ref, sref1: selectedWrongItem.sref1, sref2: selectedWrongItem.sref2 }
        : null;

    //Both the incoming and the outgoing item reference the original ordered line (selectedItemIn)
    //via originalItemId + sourceMouvementNb; only ref/sref differ for an exchange's replacement.
    const sourceOriginalItemId = selectedItemIn?.originalItemId;
    const sourceMouvementNb = selectedItemIn?.mouvementNb;

    /** @type {object[]} */
    const itemObjects = [];
    //Incoming item: the article the customer is sending back (direction 1 = Incoming)
    itemObjects.push({
        originalItemId: sourceOriginalItemId,
        sourceMouvementNb: sourceMouvementNb,
        ref: selectedItemIn?.ref,
        sref1: selectedItemIn?.sref1,
        sref2: selectedItemIn?.sref2,
        direction: 1,
        leftWrongArticle: wrongArticle,
        rightWrongArticle: wrongArticle
    });
    //Outgoing item (direction 2 = Outgoing): the replacement being shipped out
    if (returnType == "E" || returnType == "E-W") {
        if (!selectedItemOut) throw ("Somehow no item out selected when trying to post an exchange");
        itemObjects.push({
            originalItemId: sourceOriginalItemId,
            sourceMouvementNb: sourceMouvementNb,
            ref: selectedItemOut.ref,
            sref1: selectedItemOut.sref1,
            sref2: selectedItemOut.sref2,
            direction: 2
        });
    }
    else if (returnType == "W") {
        if (!selectedItemIn) throw ("Somehow no item in selected when trying to post a warranty");
        itemObjects.push({
            originalItemId: sourceOriginalItemId,
            sourceMouvementNb: sourceMouvementNb,
            ref: selectedItemIn.ref,
            sref1: selectedItemIn.sref1,
            sref2: selectedItemIn.sref2,
            direction: 2
        });
    }

    //Cast to any: Items/ImageInputs use the server's [JsonFormList] binder, which deserializes EACH
    //repeated form field value as one list element. So send one JSON-object string per element (the
    //client appends each array entry as its own field). This diverges from the generated
    //Array<object> parameter types.
    /** @type {any} */
    const requestParameters = {
        orderId: selectedOrder?.orderId, //internal DivZero order id
        websiteId: siteId,
        email: returnExchangeWrarrantyPageData.userEmail ?? emailInput?.value,
        //WebReturnRequestStatusEnum: New = 0, a request made by the customer always starts there
        initialStatus: 0,
        initialType: initialType,
        reason: returnReason,
        reasonDescription: returnReasonDescription,
        items: itemObjects.map(item => JSON.stringify(item)),
        images: requestImages,
        imageInputs: imageInputObjects.map(imageInput => JSON.stringify(imageInput))
    };

    const shippingAddress = selectedOrder?.shippingAddress;
    if (shippingAddress?.id != null) {
        //Unchanged address: reference the existing one by id
        requestParameters.shpAdrId = shippingAddress.id;
    }
    else if (shippingAddress) {
        //Address was edited (its id is cleared in saveShippingAddressEdit): create it inline
        requestParameters.newShpAdrCountryCode = shippingAddress.countryCode;
        requestParameters.newShpAdrRegionCode = shippingAddress.regionCode;
        requestParameters.newShpAdrCity = shippingAddress.city;
        requestParameters.newShpAdrPostalCode = shippingAddress.postalCode;
        requestParameters.newShpAdrStreet = shippingAddress.street;
        requestParameters.newShpAdrLocal = shippingAddress.local;
        requestParameters.newShpAdrFirstName = shippingAddress.firstName;
        requestParameters.newShpAdrLastName = shippingAddress.lastName;
        requestParameters.newShpAdrCompany = shippingAddress.company;
        requestParameters.newShpAdrPhoneNb = shippingAddress.phoneNb;
        requestParameters.newShpAdrAdditionalInfo = shippingAddress.additionalInfo;
    }

    try {
        let result = await returnExchangeWarrantyWebReturnRequestApi.webReturnRequestCreateWebReturnRequest(requestParameters);

        if (result.value) {
            allowNextSlideBtn(true);
            requestCreatedEmailP.innerText = returnExchangeWrarrantyPageData.userEmail ?? emailInput?.value ?? "";
            let returnTypeText = null;
            if (returnType == "R" || returnType == "R-W") returnTypeText = templatesWrapper.querySelector(".returnText")?.innerHTML
            if (returnType == "E" || returnType == "E-W") returnTypeText = templatesWrapper.querySelector(".exchangeText")?.innerHTML
            if (returnType == "W") returnTypeText = templatesWrapper.querySelector(".warrantyText")?.innerHTML
            requestTypeConfirmation.innerText = returnTypeText ?? "";
            swiperNextBtnEl?.classList.remove("swiperBtn");
            swiperPrevBtnEl?.classList.remove("swiperBtn");
            swiperReturn.slideTo(getIndexOfChild(requestCreatedSlide));
        }
        else {
            allowNextSlideBtn(true);
            swiperNextBtnEl?.classList.remove("swiperBtn");
            swiperPrevBtnEl?.classList.remove("swiperBtn");
            swiperReturn.slideTo(getIndexOfChild(requestFailedSlide));
        }
    }
    catch (error) {
        //Hide the loader again
        siteLoader.hide();
        console.log(error)
        allowNextSlideBtn(true);
        swiperReturn.slideTo(getIndexOfChild(requestFailedSlide));
        swiperNextBtnEl?.classList.remove("swiperBtn");
        swiperPrevBtnEl?.classList.remove("swiperBtn");
    }

    //Hide the loader again
    siteLoader.hide();
}

function startReturnBtnClicked() {
    allowNextSlideBtn(true);
    swiperReturn.slideNext();
}

function startBtnClickedLoggedIn() {
    if (selectedOrder) {
        allowNextSlideBtn(true);
        swiperReturn.slideNext();
    }
}

async function startBtnClicked() {
    //If the order is the same that was already loaded don't load it again
    if (selectedOrder && selectedOrder.websiteOrderId?.toString() == orderIdInput.value.trim()) {
        invalidStartInfoP?.classList.add("invisible");

        swiperReturn.allowSlideNext = true;
        swiperReturn.slideNext();

        return;
    }

    //show the loader
    siteLoader.show();

    try {
        const fetchedOrder = await returnExchangeWarrantyWebOrderApi.webOrderGetShippedOrderByWebsiteOrderIdAndEmail(
            {
                websiteId: siteId,
                websiteOrderId: parseInt(orderIdInput.value, 10) || 0,
                email: emailInput.value
            });
        //Articles come grouped by mouvementNb; expand them into one unit per row for the UI
        selectedOrder = fetchedOrder ? separateOrderArticles(fetchedOrder) : null;
    }
    catch (error) {
        //Hide the loader again
        siteLoader.hide();
        console.log(error)
        allowNextSlideBtn(true);
        swiperReturn.slideTo(getIndexOfChild(requestFailedSlide));
        swiperNextBtnEl?.classList.remove("swiperBtn");
        swiperPrevBtnEl?.classList.remove("swiperBtn");
    }

    if (selectedOrder) {
        //Set selected order ID
        orderIdElement.value = orderIdInput.value;

        //Reset step 2
        returnType = "";
        setupStep2(selectedOrder);

        //Reset step 3
        resetStep3In();
        resetStep3Out();
        setupStep3(selectedOrder);

        orderNumberSpan.forEach(nbSpan => nbSpan.innerText = selectedOrder?.websiteOrderId?.toString() ?? "");
        orderDateSpan.forEach(dateSpan => dateSpan.innerText = formatDate(selectedOrder?.placedOn ?? new Date()));

        invalidStartInfoP?.classList.add("invisible");

        swiperReturn.allowSlideNext = true;
        swiperReturn.slideNext();
    }
    else {
        invalidStartInfoP?.classList.remove("invisible");
    }
    //Hide the loader again
    siteLoader.hide();
}

/**
 * 
 * @param {Event} e 
 */
function orderSelectChange(e) {
    const selectedOrderId = /** @type {HTMLInputElement} */ (e.target).value;
    selectedOrder = orders.find(order => order.websiteOrderId?.toString() == selectedOrderId) ?? null;

    if (!selectedOrder) throw ("Couldn't find selected order in the list");

    //Set selected order ID
    orderIdElement.value = selectedOrderId;

    //Reset step 2
    returnType = "";
    setupStep2(selectedOrder);

    //Reset step 3
    resetStep3In();
    resetStep3Out();
    setupStep3(selectedOrder);

    orderNumberSpan.forEach(nbSpan => nbSpan.innerText = selectedOrder?.websiteOrderId?.toString() ?? "");
    orderDateSpan.forEach(dateSpan => dateSpan.innerText = formatDate(selectedOrder?.placedOn ?? new Date()));

    if (submitOrderChoiceBtn) submitOrderChoiceBtn.disabled = false;
}

/**
 * The API returns each ordered article once, grouped by its mouvementNb, with
 * quantity fields (orderedQty, returnedQty, exchangedQty, ...) instead of one
 * entry per physical unit like the old API did. The UI still works with one row
 * per unit, so expand every grouped article into orderedQty units and tag the
 * ones already used up by a completed OR in-progress request so they show as
 * unavailable.
 * @param {DivZeroWebPublicModels.CustomerShippedOrder} order
 * @returns {ReturnExchangeWarrantyOrder}
 */
function separateOrderArticles(order) {
    /** @type {ReturnExchangeWarrantyOrderUnit[]} */
    const separatedItems = [];

    (order.items ?? []).forEach(groupedItem => {
        const orderedQty = groupedItem.orderedQty ?? 0;
        //In progress quantities count as used up too, so a unit can't be requested twice
        const returnedQty = (groupedItem.returnedQty ?? 0) + (groupedItem.returningQty ?? 0);
        const exchangedQty = (groupedItem.exchangedQty ?? 0) + (groupedItem.exchangingQty ?? 0);
        const warrantiedQty = (groupedItem.warrantiedQty ?? 0) + (groupedItem.warrantyingQty ?? 0);

        for (let i = 0; i < orderedQty; i++) {
            /** @type {ReturnExchangeWarrantyOrderUnit} */
            const unit = {
                ...groupedItem,
                uid: groupedItem.mouvementNb + "-" + i,
                returned: false,
                exchanged: false,
                warrantied: false
            };
            //Mark the used up units first, in order: returned, then exchanged, then warrantied
            if (i < returnedQty) unit.returned = true;
            else if (i < returnedQty + exchangedQty) unit.exchanged = true;
            else if (i < returnedQty + exchangedQty + warrantiedQty) unit.warrantied = true;

            separatedItems.push(unit);
        }
    });

    order.items = separatedItems;
    return /** @type {ReturnExchangeWarrantyOrder} */ (order);
}

/**
 * The API no longer exposes a single order-level shipped date because articles
 * can ship separately, so use the most recent article shipped date as a
 * representative value for the whole-order checks. The precise per-article date
 * is used in rowSelected once an article is actually picked.
 * @param {ReturnExchangeWarrantyOrder} order
 * @returns {Date}
 */
function getOrderShippedDate(order) {
    /** @type {number | null} */
    let latest = null;
    (order.items ?? []).forEach(item => {
        if (!item.shippedDate) return;
        const time = new Date(item.shippedDate).getTime();
        if (latest == null || time > latest) latest = time;
    });
    return latest == null ? new Date(order.placedOn ?? new Date()) : new Date(latest);
}

/**
 * @param {ReturnExchangeWarrantyOrder} order
 */
function setupStep2(order) {
    const nbOfDaysSinceShipping = (Date.now() - getOrderShippedDate(order).getTime()) / (1000 * 3600 * 24);

    const typeDivs = /** @type {HTMLElement[]} */ (Array.from(typeSelectWrapper.querySelectorAll(".returnRequestSelectableDiv")));

    const adminInfoReturnWrapper = typeSelectWrapper.querySelector(".returnRequestAdminWrapper[data-value='R']");
    const adminInfoExchangeWrapper = typeSelectWrapper.querySelector(".returnRequestAdminWrapper[data-value='E']");

    if (nbOfDaysSinceShipping < maxDaysReturnExchange) {
        adminInfoReturnWrapper?.classList.add("d-none");
        adminInfoExchangeWrapper?.classList.add("d-none");
        typeDivs.find(div => div.dataset.value == "R")?.classList.remove("disabled");
        typeDivs.find(div => div.dataset.value == "E")?.classList.remove("disabled");
    }
    else {
        typeDivs.find(div => div.dataset.value == "R")?.classList.add("disabled");
        typeDivs.find(div => div.dataset.value == "E")?.classList.add("disabled");

        isIpRestricted().then(isRestricted => {
            if (isRestricted) {
                typeDivs.find(div => div.dataset.value == "R")?.classList.remove("disabled");
                typeDivs.find(div => div.dataset.value == "E")?.classList.remove("disabled");
                adminInfoReturnWrapper?.classList.remove("d-none");
                adminInfoExchangeWrapper?.classList.remove("d-none");
            }
            else {
                adminInfoReturnWrapper?.classList.add("d-none");
                adminInfoExchangeWrapper?.classList.add("d-none");
            }

        });
    }
    if (nbOfDaysSinceShipping < maxDaysWarranty) {
        typeDivs.find(div => div.dataset.value == "W")?.classList.remove("disabled");
    }
    else {
        typeDivs.find(div => div.dataset.value == "W")?.classList.add("disabled");

        isIpRestricted().then(isRestricted => {
            const adminInfoWarrantyWrapper = typeSelectWrapper.querySelector(".returnRequestAdminWrapper[data-value='W']");
            if (isRestricted) {
                typeDivs.find(div => div.dataset.value == "W")?.classList.remove("disabled");
                adminInfoWarrantyWrapper?.classList.remove("d-none");
            }
            else {
                adminInfoWarrantyWrapper?.classList.add("d-none");
            }
        });
    }
}

function resetStep3In() {
    selectedItemIn = null;
    crtSelectedRow?.classList.remove(selectedClassName);
    crtSelectedRow = null;
    returnInArticleWrapper.innerHTML = "";
}

function resetStep3Out() {
    selectedItemOut = null;
    returnOutSelectedSref1 = null;
    returnOutSelectedSref2 = null;
    exchangeSizeSelection.innerHTML = "";
    exchangeWidthSelection.innerHTML = "";
}

/**
 * @param {ReturnExchangeWarrantyOrder} order
 */
function setupStep3(order) {
    order.items?.forEach(item => {
        const articleEl = createArticleElement(item);
        articleEl.onclick = rowSelected;
        returnInArticleWrapper.appendChild(articleEl);
    });

    crtSelectedRow?.classList.remove(selectedClassName);
    crtSelectedRow = null;
    selectedItemIn = null;
    resetWrongItemSelection();
}

function resetWrongItemSelection(resetRefInput = true) {
    selectedWrongItem = null;
    if (resetRefInput) wrongRefInput.value = "";
    wrongBootsSizeSelection.innerHTML = "";
    wrongBootsWidthSelection.innerHTML = "";
    wrongBootsSelectedSref1 = null;
    wrongBootsSelectedSref2 = null;
    wrongBootsSizeSelectionArticleBox.innerHTML = "";
    wrongBootsSizeSelectionSection.classList.add("d-none")
    wrongBootsWidthSelectionSection.classList.add("d-none")
}

function wrongItemReceived() {
    if (!returnType.endsWith("-W")) returnType = returnType + '-W';
    wrongBootShouldReceiveArticles.innerHTML = "";
    selectedOrder?.items?.forEach(item => {
        const articleEl = createArticleElement(item);
        articleEl.onclick = rowSelected;
        wrongBootShouldReceiveArticles.appendChild(articleEl);
    });
    allowNextSlideBtn(true);
    swiperReturn.slideNext();
}

function wrongRefInputChange() {
    if (Array.from(wrongRefDatalist.options).some(option => option.innerText == wrongRefInput.value)) {
        selectedWrongItem = {
            ref: wrongRefInput.value,
            sref1: null,
            sref2: null,
            availableQty: 0
        };
        const img = document.createElement("img");
        img.src = returnExchangeWrarrantyPageData.baseCdnPath + wrongRefInput.value + "_SIDE.jpg";
        img.width = 150;
        img.height = 150;
        img.className = "border rounded"
        img.onerror = () => {
            const fallbackSrc = returnExchangeWrarrantyPageData.baseCdnPathFallback + wrongRefInput.value + "_SIDE.jpg";
            if (img.src != fallbackSrc) img.src = fallbackSrc;
        };
        wrongBootsSizeSelectionArticleBox.appendChild(img);

        swiperReturn.update();

        const setSelectedSref1Func = (/** @type {HTMLButtonElement}*/newSelectedSref1) => wrongBootsSelectedSref1 = newSelectedSref1;
        const setSelectedSref2Func = (/** @type {HTMLButtonElement}*/newSelectedSref2) => wrongBootsSelectedSref2 = newSelectedSref2;
        const getSelectedSref1Func = () => { return wrongBootsSelectedSref1 };
        const getSelectedSref2Func = () => { return wrongBootsSelectedSref2 };
        setupSrefSelection(wrongBootsSizeSelectionSection, wrongBootsSizeSelection, wrongBootsWidthSelectionSection, wrongBootsWidthSelection, setSelectedSref1Func, getSelectedSref1Func, setSelectedSref2Func, getSelectedSref2Func, selectedWrongItem, null, false);
    }
    else {
        resetWrongItemSelection(false);
        swiperReturn.update();
    }
}

/**
 * 
 * @param {string} type 
 */
function typeSelectChange(type) {
    //If the type isn't disabled
    if (!typeSelectWrapper.querySelector(`.returnRequestSelectableDiv[data-value=${type}]`)?.classList.contains("disabled")) {
        //Deselect selected item
        resetStep3Out();

        selectedItemOut = null;
        returnOutSelectedSref1 = null;
        returnOutSelectedSref2 = null;

        returnType = type + (returnType == "-W" ? returnType : "");

        if (returnType == "E" || returnType == "E-W") {
            selectedItemOut = { ...selectedItemIn };
            selectedItemOut.sref1 = null;
            selectedItemOut.sref2 = null;
        }

        //If the type is a return
        if (returnType == "R" || returnType == "R-W") {
            const computedItemIn = selectedWrongItem ?? selectedItemIn;
            if (!computedItemIn) throw ("No item in selected when warranty selected");
            fillArticleBox(returnQuestionOneArticleBox, computedItemIn)
        }
        //If the type is exchange show the size selection section
        else if (returnType == "E" || returnType == "E-W") {
            setupReturnOut();
        }
        //If the type is a warranty
        else if (returnType == "W") {
            if (!selectedItemIn) throw ("No item in selected when warranty selected");
            fillArticleBox(warrantyQuestionOneArticleBox, selectedItemIn)
        }
        allowNextSlideBtn(true);
        swiperReturn.slideNext();
    }
}

/**
 * 
 * @param {HTMLElement} articleBox 
 * @param {DivZeroWebPublicModels.CustomerShippedOrderArticle} item 
 * @param {string} titleClass 
 */
function fillArticleBox(articleBox, item, titleClass = yourModelTitleClass) {
    articleBox.innerHTML = createArticleElement(item, titleClass).outerHTML;
    articleBox.children[0].classList.remove("selectedReturnRow");
    articleBox.children[0].classList.add("noHover");
}

/**
 * 
 * @param {Event} e 
 * @returns 
 */
function rowSelected(e) {
    //currentTarget is the article row the handler is bound to; e.target may be an inner
    //element (image, text) that doesn't carry the dataset.uid used to match the item.
    const row = /** @type {HTMLElement} */ (e.currentTarget);

    //If the article isn't available do nothing
    if (row.classList.contains("articleNotAvailable")) return;

    selectedItemIn = selectedOrder?.items?.find(item => item.uid == row.dataset.uid) ?? null;

    if (!selectedItemIn) throw ("A row was selected but couldn't find the matching item in the order");

    //If a row was already selected remove the class from it
    if (crtSelectedRow) crtSelectedRow.classList.remove(selectedClassName);

    returnOutSelectedSref1 = null;
    returnOutSelectedSref2 = null;

    crtSelectedRow = row;
    crtSelectedRow.classList.add(selectedClassName);

    fillArticleBox(returnTypeArticleBox, selectedWrongItem ?? selectedItemIn)

    swiperNextBtnEl.classList.add("swiperBtn")

    //If the article is discontinued and it was discontinued when they bought it
    const selectedProductIn = returnExchangeWrarrantyPageData.allValidProducts.find(product => product.handle.toUpperCase() == selectedItemIn?.ref);
    let useDiscontinuedLogic = selectedProductIn?.discontinuedDate != null && selectedProductIn.discontinuedDate < (selectedOrder?.placedOn ?? new Date());

    const nbOfDaysSinceShipping = (Date.now() - new Date(selectedItemIn.shippedDate ?? new Date()).getTime()) / (1000 * 3600 * 24);

    const typeDivs = /** @type {HTMLElement[]}*/ (Array.from(typeSelectWrapper.querySelectorAll(".returnRequestSelectableDiv")));
    if ((!useDiscontinuedLogic && nbOfDaysSinceShipping < maxDaysReturnExchange) || (useDiscontinuedLogic && nbOfDaysSinceShipping < maxDaysReturnExchangeDiscontinued)) {
        typeDivs.find(div => div.dataset.value == "R")?.classList.remove("disabled");
        typeDivs.find(div => div.dataset.value == "E")?.classList.remove("disabled");
    }
    else {
        typeDivs.find(div => div.dataset.value == "R")?.classList.add("disabled");
        typeDivs.find(div => div.dataset.value == "E")?.classList.add("disabled");

        isIpRestricted().then(isRestricted => {
            const adminInfoReturnWrapper = /** @type {HTMLElement}*/ (typeSelectWrapper.querySelector(".returnRequestAdminWrapper[data-value='R']"));
            const adminInfoExchangeWrapper = /** @type {HTMLElement}*/ (typeSelectWrapper.querySelector(".returnRequestAdminWrapper[data-value='E']"));
            if (isRestricted) {
                typeDivs.find(div => div.dataset.value == "R")?.classList.remove("disabled");
                typeDivs.find(div => div.dataset.value == "E")?.classList.remove("disabled");
                adminInfoReturnWrapper?.classList.remove("d-none");
                adminInfoExchangeWrapper?.classList.remove("d-none");
            }
            else {
                adminInfoReturnWrapper?.classList.add("d-none");
                adminInfoExchangeWrapper?.classList.add("d-none");
            }

        });
    }
    if ((!useDiscontinuedLogic && nbOfDaysSinceShipping < maxDaysWarranty) || (useDiscontinuedLogic && nbOfDaysSinceShipping < maxDaysWarrantyDiscontinued)) {
        typeDivs.find(div => div.dataset.value == "W")?.classList.remove("disabled");
    }
    else {
        typeDivs.find(div => div.dataset.value == "W")?.classList.add("disabled");

        isIpRestricted().then(isRestricted => {
            const adminInfoWarrantyWrapper = typeSelectWrapper.querySelector(".returnRequestAdminWrapper[data-value='W']");
            if (isRestricted) {
                typeDivs.find(div => div.dataset.value == "W")?.classList.remove("disabled");
                adminInfoWarrantyWrapper?.classList.remove("d-none");
            }
            else {
                adminInfoWarrantyWrapper?.classList.add("d-none");
            }
        });
    }

    swiperNextBtnEl.scrollIntoView(false);
    allowNextSlideBtn(true);
}

function returnTurnedExchanged() {
    if (returnType == "R") returnType = "E";
    else if (returnType == "R-W") returnType = "E-W";

    selectedItemIn = selectedOrder?.items?.find(item => item.uid == crtSelectedRow?.dataset.uid) ?? null;
    selectedItemOut = { ...selectedItemIn };
    selectedItemOut.sref1 = null;
    selectedItemOut.sref2 = null;

    setupReturnOut();

    allowNextSlideBtn(true);
    swiperReturn.slideNext();
}

function refundFullAmountClicked() {
    if (!selectedItemIn) throw ("refund full amount clicked but no item in selected");
    fillArticleBox(returnQuestionTwoArticleBox, selectedItemIn);
    allowNextSlideBtn(true);
    swiperReturn.slideNext();
}

/**
 * 
 * @param {HTMLLegendElement} el 
 */
function returnQuestionTwoClick(el) {
    const type = el.dataset.type ?? null;
    returnReason = type;

    let shownChild = [];
    (/** @type {HTMLElement[]}*/(Array.from(returnQuestionThreeWrapper.children))).forEach(child => {
        if (child.dataset.type == type) {
            shownChild.push(child);
            child.classList.remove("d-none");
        }
        else child.classList.add("d-none");
    });

    if (!selectedItemIn) throw ("trying to setup question for item in but no item in selected");
    fillArticleBox(returnQuestionThreeArticleBox, selectedItemIn);

    returnReasonOtherInput.value = "";

    allowNextSlideBtn(true);
    if (returnReason == "other") swiperReturn.slideTo(getIndexOfChild(returnQuestionThreeOtherSlide));
    else swiperReturn.slideNext();
}

/**
 * 
 * @param {HTMLLegendElement} el 
 */
function returnQuestionThreeClick(el) {
    const type = el.dataset.type?.split("_") ?? null;
    const baseType = type?.at(0);
    const lastType = type?.at(1);

    returnReason = el.dataset.type ?? null;

    //Reset "other" text area
    returnReasonOtherInput.value = "";

    if (lastType == "other") {
        if (!selectedItemIn) throw ("Missing selected item in");
        fillArticleBox(returnQuestionThreeOtherArticleBox, selectedItemIn);
        returnQuestionThreeOtherTitle.innerText = returnQuestionTwoSlide.querySelector("div[data-type=" + baseType + "]")?.querySelector(".selectableDivText")?.innerHTML ?? "";
        allowNextSlideBtn(true);
        swiperReturn.slideTo(getIndexOfChild(returnQuestionThreeOtherSlide));
        swiperNextBtnEl.classList.add("swiperBtn")
        allowNextSlideBtn(true);
    }
    else {
        allowNextSlideBtn(true);
        swiperReturn.slideTo(getIndexOfChild(imagesSlide));
    }
}

/**
 * 
 * @param {HTMLElement} el 
 */
function warrantyQuestionOneClick(el) {
    returnReason = el.dataset.type ?? null;

    allowNextSlideBtn(true);
    swiperReturn.slideNext();
}

function setupReturnOut() {
    const showStockOnBtn = false;

    const computedItem = selectedItemOut ?? selectedItemIn;

    if (!computedItem) throw ("No item in selected when trying to go to return out.");

    fillArticleBox(exchangeSizeSelectionArticleBox, computedItem, selectedItemOut ? newModelTitleClass : yourModelTitleClass);
    const setSelectedSref1Func = (/** @type {HTMLButtonElement}*/newSelectedSref1) => returnOutSelectedSref1 = newSelectedSref1;
    const setSelectedSref2Func = (/** @type {HTMLButtonElement}*/newSelectedSref2) => returnOutSelectedSref2 = newSelectedSref2;
    const getSelectedSref1Func = () => { return returnOutSelectedSref1 };
    const getSelectedSref2Func = () => { return returnOutSelectedSref2 };
    if (!selectedItemOut) throw ("No item out selected when trying to setup sref selection for it");
    setupSrefSelection(exchangeSizeSelectionSection, exchangeSizeSelection, exchangeWidthSelectionSection, exchangeWidthSelection, setSelectedSref1Func, getSelectedSref1Func, setSelectedSref2Func, getSelectedSref2Func, selectedItemOut, selectedWrongItem ? null : selectedItemIn, showStockOnBtn);
}

/**
 * 
 * @param {HTMLElement} sizeSelectionSection 
 * @param {HTMLElement} sizeSelection 
 * @param {HTMLElement} widthSelectionSection 
 * @param {HTMLElement} widthSelection 
 * @param {(newSelectedSref1: HTMLButtonElement) => HTMLButtonElement} setSelectedSref1Func 
 * @param {() => HTMLButtonElement | null} getSelectedSref1Func 
 * @param {(newSelectedSref2: HTMLButtonElement) => HTMLButtonElement} setSelectedSref2Func 
 * @param {() => HTMLButtonElement | null} getSelectedSref2Func 
 * @param {DivZeroWebPublicModels.CustomerShippedOrderArticle} item 
 * @param {DivZeroWebPublicModels.CustomerShippedOrderArticle | null} itemToDisableSizeFor 
 * @param {Boolean} showStock 
 */
function setupSrefSelection(sizeSelectionSection, sizeSelection, widthSelectionSection, widthSelection, setSelectedSref1Func, getSelectedSref1Func, setSelectedSref2Func, getSelectedSref2Func, item, itemToDisableSizeFor = null, showStock = true) {
    sizeSelection.innerHTML = "";
    widthSelection.innerHTML = "";

    const possibleSizes = returnExchangeWrarrantyPageData.allValidProducts.find(product => product.handle.toUpperCase() == item.ref)?.sizes;
    const possibleSref1 = [...new Set(possibleSizes?.map((item) => item.sref1))];
    const possibleSref2 = [...new Set(possibleSizes?.map((item) => item.sref2))];

    if (possibleSref2.length < 2) sizeSelectionSection.classList.add("d-none");
    else sizeSelectionSection.classList.remove("d-none");

    if (possibleSref1.length < 2) widthSelectionSection.classList.add("d-none");
    else widthSelectionSection.classList.remove("d-none");

    possibleSref1.forEach(sref1 => {
        let variantBtn = document.createElement("button");
        variantBtn.classList.add("variantBtn");
        variantBtn.dataset.value = sref1;
        variantBtn.innerHTML = sref1;
        variantBtn.onclick = (e) => { newSref1Selected(e, sizeSelection, widthSelection, setSelectedSref1Func, getSelectedSref1Func, getSelectedSref2Func, item, itemToDisableSizeFor, showStock) };;
        //Automaticly select the option if it's the only one
        if (possibleSref1.length == 1) {
            variantBtn.classList.add("selected")
            setSelectedSref1Func(variantBtn);
            item.sref1 = possibleSref1[0];
        };

        widthSelection.appendChild(variantBtn);
    });

    possibleSref2.forEach(sref2 => {
        let variantBtn = document.createElement("button");
        variantBtn.classList.add("variantBtn");
        //If the sref1 currently selected and the current size button beeing created are the same as the selected item and the model is the same disable the button
        if (itemToDisableSizeFor && item.ref == itemToDisableSizeFor.ref && item.sref1 == itemToDisableSizeFor.sref1 && sref2 == itemToDisableSizeFor.sref2) {
            variantBtn.disabled = true;
            variantBtn.title = "";
        }
        variantBtn.dataset.value = sref2;
        variantBtn.innerHTML = sref2;
        variantBtn.onclick = (e) => { newSref2Selected(e, sizeSelection, widthSelection, getSelectedSref1Func, setSelectedSref2Func, getSelectedSref2Func, item, itemToDisableSizeFor, showStock) };
        //Automaticly select the option if it's the only one
        if (possibleSref2.length == 1) {
            variantBtn.classList.add("selected");
            setSelectedSref2Func(variantBtn);
            item.sref2 = possibleSref2[0];
        }

        sizeSelection.appendChild(variantBtn);
    });

    updateSizeBtnStockStyle(sizeSelection, widthSelection, getSelectedSref1Func(), getSelectedSref2Func(), item, itemToDisableSizeFor, showStock);

    //Force the swiper to update the height after showing the size select section
    swiperReturn.update();
}

/**
 * 
 * @param {Event} e 
 * @param {HTMLElement} sizeSelection 
 * @param {HTMLElement} widthSelection 
 * @param {(newSelectedSref1: HTMLButtonElement) => HTMLButtonElement} setSelectedSref1Func 
 * @param {() => HTMLButtonElement | null} getSelectedSref1Func 
 * @param {() => HTMLButtonElement | null} getSelectedSref2Func 
 * @param {DivZeroWebPublicModels.CustomerShippedOrderArticle} item 
 * @param {DivZeroWebPublicModels.CustomerShippedOrderArticle | null} itemToDisableSizeFor 
 * @param {Boolean} showStock 
 */
function newSref1Selected(e, sizeSelection, widthSelection, setSelectedSref1Func, getSelectedSref1Func, getSelectedSref2Func, item, itemToDisableSizeFor = null, showStock = true) {
    let selectedSref1 = getSelectedSref1Func();
    if (selectedSref1) selectedSref1.classList.remove("selected");
    selectedSref1 = /** @type {HTMLButtonElement} */ (/** @type {HTMLInputElement} */ (e.target).closest("button"))
    setSelectedSref1Func(selectedSref1);
    selectedSref1.classList.add("selected");

    item.sref1 = selectedSref1.dataset.value;

    updateSizeBtnStockStyle(sizeSelection, widthSelection, selectedSref1, getSelectedSref2Func(), item, itemToDisableSizeFor, showStock);

    if (checkSrefSelection(selectedSref1, getSelectedSref2Func(), item)) {
        swiperNextBtnEl.classList.add("swiperBtn")
        allowNextSlideBtn(true);
    }
}

/**
 * 
 * @param {Event} e 
 * @param {HTMLElement} sizeSelection 
 * @param {HTMLElement} widthSelection 
 * @param {() => HTMLButtonElement | null} getSelectedSref1Func 
 * @param {(newSelectedSref2: HTMLButtonElement) => HTMLButtonElement} setSelectedSref2Func 
 * @param {() => HTMLButtonElement | null} getSelectedSref2Func 
 * @param {DivZeroWebPublicModels.CustomerShippedOrderArticle} item 
 * @param {DivZeroWebPublicModels.CustomerShippedOrderArticle | null} itemToDisableSizeFor 
 * @param {Boolean} showStock 
 */
function newSref2Selected(e, sizeSelection, widthSelection, getSelectedSref1Func, setSelectedSref2Func, getSelectedSref2Func, item, itemToDisableSizeFor = null, showStock = true) {
    let selectedSref2 = getSelectedSref2Func();
    if (selectedSref2) selectedSref2.classList.remove("selected");
    selectedSref2 = /** @type {HTMLButtonElement} */ (/** @type {HTMLInputElement} */ (e.target).closest("button"))
    setSelectedSref2Func(selectedSref2);
    selectedSref2.classList.add("selected");

    item.sref2 = selectedSref2.dataset.value;

    updateSizeBtnStockStyle(sizeSelection, widthSelection, getSelectedSref1Func(), selectedSref2, item, itemToDisableSizeFor, showStock);

    if (checkSrefSelection(getSelectedSref1Func(), selectedSref2, item)) {
        swiperNextBtnEl.classList.add("swiperBtn")
        allowNextSlideBtn(true);
    }
}

/**
 * 
 * @param {HTMLButtonElement | null} selectedSref1 
 * @param {HTMLButtonElement | null} selectedSref2 
 * @param {DivZeroWebPublicModels.CustomerShippedOrderArticle | null} item 
 * @returns 
 */
function checkSrefSelection(selectedSref1, selectedSref2, item) {
    if (selectedSref2 && selectedSref1 && item) {
        const size = returnExchangeWrarrantyPageData.allValidProducts.find(product => product.handle.toUpperCase() == item.ref)?.sizes.find(size => size.sref1 == selectedSref1.dataset.value && size.sref2 == selectedSref2.dataset.value);
        return size != null && size != undefined;
    }
    return false;
}

/**
 * 
 * @param {HTMLElement} sizeSelectionWrapper 
 * @param {HTMLElement} widthSelectionWrapper 
 * @param {HTMLButtonElement | null} selectedSref1 
 * @param {HTMLButtonElement | null} selectedSref2 
 * @param {DivZeroWebPublicModels.CustomerShippedOrderArticle} item 
 * @param {DivZeroWebPublicModels.CustomerShippedOrderArticle | null} itemToDisableSizeFor 
 * @param {Boolean} showStock 
 */
function updateSizeBtnStockStyle(sizeSelectionWrapper, widthSelectionWrapper, selectedSref1, selectedSref2, item, itemToDisableSizeFor = null, showStock = true) {
    const stockTitlePrefix = templatesWrapper.querySelector(".articleStockAvailable")?.innerHTML ?? "";
    const sref2Btns = /** @type {NodeListOf<HTMLButtonElement>}*/ (sizeSelectionWrapper.querySelectorAll(".variantBtn"));
    const sref1Btns = /** @type {NodeListOf<HTMLButtonElement>}*/ (widthSelectionWrapper.querySelectorAll(".variantBtn"));

    if (selectedSref1) {
        sref2Btns.forEach(btn => {
            const size = returnExchangeWrarrantyPageData.allValidProducts.find(product => product.handle.toUpperCase() == item.ref)?.sizes.find(size => size.sref1 == item.sref1 && size.sref2 == btn.dataset.value);
            if (size) {
                if (itemToDisableSizeFor)
                    btn.disabled = itemToDisableSizeFor.ref == item.ref && itemToDisableSizeFor.sref1 == item.sref1 && btn.dataset.value == itemToDisableSizeFor.sref2;
                else btn.disabled = false;
                if (showStock) {
                    btn.title = stockTitlePrefix + (size.qtyAvailable < 0 ? 0 : size.qtyAvailable);
                    btn.classList.remove("noStocks");
                    btn.classList.remove("lowStocks");
                    if (size.qtyAvailable <= 0) btn.classList.add("noStocks");
                    else if (size.qtyAvailable < lowStockTreshold) btn.classList.add("lowStocks");
                }
            }
            else {
                btn.disabled = true;
                btn.title = "";
            }
        });
    }
    else {
        sref2Btns.forEach(btn => {
            btn.classList.remove("noStocks");
            btn.classList.remove("lowStocks");
            btn.title = "";
        });
    }
    if (selectedSref2) {
        sref1Btns.forEach(btn => {
            const size = returnExchangeWrarrantyPageData.allValidProducts.find(product => product.handle.toUpperCase() == item.ref)?.sizes.find(size => size.sref1 == btn.dataset.value && size.sref2 == item.sref2);
            if (size) {
                if (itemToDisableSizeFor)
                    btn.disabled = itemToDisableSizeFor.ref == item.ref && itemToDisableSizeFor.sref2 == item.sref2 && btn.dataset.value == itemToDisableSizeFor.sref1;
                else btn.disabled = false;
                if (showStock) {
                    btn.title = stockTitlePrefix + (size.qtyAvailable < 0 ? 0 : size.qtyAvailable);
                    btn.classList.remove("noStocks");
                    btn.classList.remove("lowStocks");
                    if (size.qtyAvailable <= 0) btn.classList.add("noStocks");
                    else if (size.qtyAvailable < lowStockTreshold) btn.classList.add("lowStocks");
                }
            }
            else {
                btn.disabled = true;
                btn.title = "";
            }
        });
    }
    else {
        sref1Btns.forEach(btn => {
            btn.classList.remove("noStocks");
            btn.classList.remove("lowStocks");
            btn.title = "";
        });
    }
}

/**
 * 
 * @param {HTMLButtonElement} btnEl 
 */
function changeImageBtnClicked(btnEl) {
    const fileInput = /** @type {HTMLInputElement}*/ (btnEl.querySelector("input[type='file']"));
    fileInput.click();
}

/**
 * 
 * @param {HTMLInputElement} fileInput 
 */
function imageChange(fileInput) {
    if (fileInput.files && fileInput.files[0]) {
        let reader = new FileReader();
        const fileName = fileInput.files[0].name;
        reader.onload = (/** @type {ProgressEvent<FileReader>}*/e) => {
            const imageWrapper = fileInput.closest("button");
            const imgEl = imageWrapper?.querySelector("img");
            if (imgEl) {
                imgEl.src = e.target?.result?.toString() ?? "";
                //Alt text is set to the file name without the extension
                imgEl.alt = fileName.split(".")[0]
            }

            imageWrapper?.classList.remove("emptyImage")

            //if all the images are now filled allow next slide
            let allImageFilled = imageInputs.every(input => Array.from(input.files ?? []).filter(file => file.type.includes('image')).length != 0);
            allowNextSlideBtn(allImageFilled);
            if (allImageFilled) swiperNextBtnEl.classList.add("swiperBtn");
            else swiperNextBtnEl.classList.remove("swiperBtn");
        };
        reader.readAsDataURL(fileInput.files[0]);
    }
}

/**
 *
 * @param {ReturnExchangeWarrantyOrderUnit} item
 * @param {string | null} titleClass
 * @returns
 */
function createArticleElement(item, titleClass = null) {
    let row = document.createElement("div");
    row.classList.add("articleRow");
    //uid identifies the individual unit (multiple units can share a mouvementNb)
    row.dataset.uid = item.uid;
    row.dataset.mouvementNb = item.mouvementNb?.toString();

    let imgWrapperDiv = document.createElement("div");
    let itemImg = document.createElement("img");
    itemImg.src = returnExchangeWrarrantyPageData.baseCdnPath + item.ref + "_SIDE.jpg";
    itemImg.onerror = () => {
        const fallbackSrc = returnExchangeWrarrantyPageData.baseCdnPathFallback + item.ref + "_SIDE.jpg";
        if (itemImg.src != fallbackSrc) itemImg.src = fallbackSrc;
    };
    itemImg.classList.add("articleImg");
    imgWrapperDiv.classList.add("articleImgWrapperDiv");
    imgWrapperDiv.appendChild(itemImg);

    let articleWrapperDiv = document.createElement("div");
    let refDiv = document.createElement("div");
    refDiv.innerHTML = "<b>" + (templatesWrapper.querySelector("." + titleClass)?.innerHTML ?? "") + "</b>" + item.ref + (item.sref1 ? "-" : "") + (item.sref1 ?? "") + (item.sref2 ? "-" : "") + (item.sref2 ?? "");
    refDiv.classList.add("articleRefWrapperDiv");

    let priceDiv = document.createElement("div");
    if (item.netUnitPrice) {
        priceDiv.innerHTML = "$" + item.netUnitPrice.toFixed(2) + " " + item.currencyCode;
        priceDiv.classList.add("articlePriceWrapperDiv")
    }
    let nunDiv = document.createElement("div");

    row.appendChild(imgWrapperDiv);
    articleWrapperDiv.appendChild(refDiv);
    articleWrapperDiv.appendChild(priceDiv);
    articleWrapperDiv.appendChild(nunDiv);
    row.appendChild(articleWrapperDiv);

    if (item.returned || item.exchanged || item.warrantied) {
        row.classList.add("articleNotAvailable");
        row.appendChild(cloneTemplate(".articleInfoEllipse"));

        if (item.returned) row.appendChild(cloneTemplate(".articleReturnedPopup"));
        else if (item.exchanged) row.appendChild(cloneTemplate(".articleExchangedPopup"));
        else if (item.warrantied) row.appendChild(cloneTemplate(".articleWarrantiedPopup"));
    }
    return row;
}

function fillFinalCheck() {
    agreeTermsCheckboxInput.checked = false;
    swiperNextBtnEl?.classList.add("swiperBtn");
    swiperNextBtnEl?.classList.remove("swiper-button-disabled");
    returnExchangeWarrantyNextBtn.classList.add("d-none");
    returnExchangeWarrantySendBtn.classList.remove("d-none");
    returnExchangeWarrantySendBtn.disabled = true;
    allowNextSlideBtn(false);

    const returnOutSref1 = returnOutSelectedSref1?.dataset.value;
    const returnOutSref2 = returnOutSelectedSref2?.dataset.value;
    //Request type
    (/** @type {HTMLElement[]}*/(Array.from(finalCheckRequestType.children))).forEach(typeEl => {
        if (typeEl.dataset.type == returnType) typeEl.classList.remove("d-none")
        else typeEl.classList.add("d-none")
    });

    //Reason
    const returnTypeWithReason = ["R", "W"];
    if (returnTypeWithReason.includes(returnType)) {
        finalCheckReasonWrapper.classList.remove("d-none");

        const prefixSplit = returnReason?.split("_");
        const firstQuestionPrefix = prefixSplit == null ? null : prefixSplit[0];
        let reason = "";

        if (returnType == "R" || returnType == "R-W") {
            if (firstQuestionPrefix) reason += "<b>" + returnQuestionTwoSlide.querySelector("div[data-type=" + firstQuestionPrefix + "]")?.querySelector(".selectableDivText")?.innerHTML;
            if (prefixSplit?.length ?? 0 > 1) reason += " > " + returnQuestionThreeSlide.querySelector("div[data-type=" + returnReason + "]")?.querySelector(".selectableDivText")?.innerHTML + "</b><br />";
            else reason += "</b><br />"
            if (returnReasonOtherInput.value) {
                reason += returnReasonOtherInput.value;
                returnReasonDescription = returnReasonOtherInput.value;
            }
        }
        else if (returnType == "W" || returnType == "W-BO") {
            if (firstQuestionPrefix) reason += "<b>" + warrantyQuestionOneSlide.querySelector("div[data-type=" + firstQuestionPrefix + "]")?.querySelector(".selectableDivText")?.innerHTML + "</b><br />";
            if (defectDescriptionInput.value) {
                reason += defectDescriptionInput.value;
                returnReasonDescription = defectDescriptionInput.value;
            }
        }

        finalCheckReason.innerHTML = reason;
    }
    else finalCheckReasonWrapper.classList.add("d-none");

    //Low / out stock warning for exchange
    finalCheckLowOnStockWarning.classList.add("d-none");
    finalCheckOutOfStockWarning.classList.add("d-none");
    if (returnOutSref1 && returnOutSref2) {
        const qtyAvailable = selectedItemOut == null ?
            0 :
            returnExchangeWrarrantyPageData.allValidProducts.find(product => product.handle.toUpperCase() == selectedItemOut?.ref)?.sizes.find(size => size.sref1 == selectedItemOut?.sref1 && size.sref2 == selectedItemOut?.sref2)?.qtyAvailable ?? 0;
        if (qtyAvailable <= 0) finalCheckOutOfStockWarning.classList.remove("d-none");
        else if (qtyAvailable < lowStockTreshold) finalCheckLowOnStockWarning.classList.remove("d-none");
    }

    //Request articles involved
    finalCheckReturnIn.innerHTML = "";
    finalCheckReturnOut.innerHTML = "";

    const computedItemIn = selectedWrongItem ?? selectedItemIn;
    if (computedItemIn != null) {
        const articleInBox = createArticleElement(computedItemIn, yourModelTitleClass);
        articleInBox.classList.add("noHover");
        articleInBox.classList.add("border-0");

        finalCheckReturnIn.appendChild(articleInBox);
    }

    if (selectedItemOut && (selectedItemOut.ref != computedItemIn?.ref || selectedItemOut.sref1 != computedItemIn?.sref1 || selectedItemOut.sref2 != computedItemIn?.sref2)) {
        const articlOutBox = createArticleElement(selectedItemOut, newModelTitleClass);
        articlOutBox.classList.add("noHover");
        articlOutBox.classList.add("border-0");

        const yourModelText = templatesWrapper.querySelector(".YourModelText")?.innerHTML;
        const innerTextOut = /** @type {HTMLElement}*/(articlOutBox.querySelector(".articleRefWrapperDiv"));
        const requestedModelText = templatesWrapper.querySelector(".YourRequestedModelText")?.innerHTML;
        innerTextOut.innerHTML = innerTextOut.innerHTML.replaceAll(yourModelText ?? "", requestedModelText ?? "");

        finalCheckReturnOut.appendChild(articlOutBox);
        finalCheckReturnOutArrow.classList.remove("d-none");
    }
    else finalCheckReturnOutArrow.classList.add("d-none");

    //Shipping address for article going out
    if (selectedItemOut || returnType == "W") {
        updateShippingAddressInfo();
        finalCheckShippingAddressWrapper.classList.remove("d-none");
    }
    else finalCheckShippingAddressWrapper.classList.add("d-none");

    //Images
    const returnTypeWithImages = ["R", "R-W", "E", "E-W", "W"];
    if (returnTypeWithImages.includes(returnType)) {
        finalCheckImagesWrapper.classList.remove("d-none");
        finalCheckImages.innerHTML = "";
        imageElements.forEach(imageEl => {
            const wrapper = document.createElement("div");
            wrapper.className = "d-flex flex-column align-items-center";

            const container = document.createElement("div");
            container.className = "finalCheckImageContainer d-flex align-items-center";
            container.appendChild(imageEl.cloneNode(true));

            const typeNameP = document.createElement("p");
            typeNameP.className = "mb-0";
            const imageTitle = imageTitles.find(imageTitle => imageTitle.dataset.type == imageEl.dataset.type);
            typeNameP.innerText = imageTitle?.innerText ?? "";

            wrapper.appendChild(container);
            wrapper.appendChild(typeNameP);

            finalCheckImages.appendChild(wrapper);
        });
    }
    else finalCheckImagesWrapper.classList.add("d-none");
}

function editShippingAddressClicked() {
    shippingAddressInfoWrapper.classList.add("collapsed");
    shippingAddressEditWrapper.classList.remove("collapsed");
    editShippingAddressBtn.classList.add("d-none");

    swiperReturn.update();
    setTimeout(() => swiperReturn.update(), 150);
}

function updateShippingAddressInfo() {
    finalCheckShippingFName.innerHTML = selectedOrder?.shippingAddress?.firstName ? selectedOrder.shippingAddress.firstName : "-";
    finalCheckShippingLName.innerHTML = selectedOrder?.shippingAddress?.lastName ? selectedOrder.shippingAddress.lastName : "-";

    if (selectedOrder?.shippingAddress?.company) {
        finalCheckShippingCompany.innerHTML = selectedOrder.shippingAddress.company;
        finalCheckShippingCompanyWrapper.classList.remove("d-none");
    }
    else finalCheckShippingCompanyWrapper.classList.add("d-none");

    finalCheckShippingAddress.innerHTML = selectedOrder?.shippingAddress?.street ? selectedOrder.shippingAddress.street : "-";

    if (selectedOrder?.shippingAddress?.local) {
        finalCheckShippingLoc.innerHTML = selectedOrder.shippingAddress.local;
        finalCheckShippingLocWrapper.classList.remove("d-none");
    }
    else {
        finalCheckShippingLocWrapper.classList.add("d-none");
    }

    finalCheckShippingCity.innerHTML = selectedOrder?.shippingAddress?.city ? selectedOrder.shippingAddress.city : "-";
    finalCheckShippingState.innerHTML = Array.from(shippingAddressEditState.options).find(option => option.value === selectedOrder?.shippingAddress?.regionCode)?.value ?? "-";
    finalCheckShippingCPostal.innerHTML = selectedOrder?.shippingAddress?.postalCode ? selectedOrder.shippingAddress.postalCode : "-";

    if (selectedOrder?.shippingAddress?.phoneNb) {
        finalCheckShippingPhone.innerHTML = selectedOrder.shippingAddress.phoneNb;
        finalCheckShippingPhoneWrapper.classList.remove("d-none");
    }
    else {
        finalCheckShippingPhoneWrapper.classList.add("d-none");
    }
}

function resetShippingAddressEdit() {
    shippingAddressEditFName.value = "";
    shippingAddressEditLName.value = "";
    shippingAddressEditCompany.value = "";
    shippingAddressEditAddress.value = "";
    shippingAddressEditLoc.value = "";
    shippingAddressEditCity.value = "";
    shippingAddressEditState.value = "";
    shippingAddressEditCPostal.value = "";
    shippingAddressEditPhone.value = "";

    shippingAddressInfoWrapper.classList.remove("collapsed");
    shippingAddressEditWrapper.classList.add("collapsed");
    editShippingAddressBtn.classList.remove("d-none");

    saveShippingAddressEditBtn.disabled = true;

    swiperReturn.update();
}

function saveShippingAddressEdit() {

    if (selectedOrder?.shippingAddress != null) {
        //Address was modified so remove the address id
        selectedOrder.shippingAddress.id = undefined;
        selectedOrder.shippingAddress.firstName = shippingAddressEditFName.value;
        selectedOrder.shippingAddress.lastName = shippingAddressEditLName.value;
        selectedOrder.shippingAddress.company = shippingAddressEditCompany.value;
        selectedOrder.shippingAddress.street = shippingAddressEditAddress.value;
        selectedOrder.shippingAddress.local = shippingAddressEditLoc.value;
        selectedOrder.shippingAddress.city = shippingAddressEditCity.value;
        selectedOrder.shippingAddress.regionCode = shippingAddressEditState.value;
        selectedOrder.shippingAddress.postalCode = shippingAddressEditCPostal.value;
        selectedOrder.shippingAddress.phoneNb = shippingAddressEditPhone.value;
        selectedOrder.shippingAddress.validationStatus = null;
    }
    updateShippingAddressInfo();
    resetShippingAddressEdit();
}

function shippingAddressEditInputChange() {
    saveShippingAddressEditBtn.disabled = !checkShippingAddressEditValidity();
}

function checkShippingAddressEditValidity() {
    if (!shippingAddressEditFName.value) return false;
    if (!shippingAddressEditLName.value) return false;
    if (!shippingAddressEditAddress.value) return false;
    if (!shippingAddressEditCity.value) return false;
    if (!shippingAddressEditState.value) return false;
    if (!shippingAddressEditCPostal.value) return false;

    //Canada only, add space between the first thre char and the last three
    if (shippingAddressEditCPostal.value.length == 6 && !shippingAddressEditCPostal.value.includes(" ")) shippingAddressEditCPostal.value = shippingAddressEditCPostal.value.substring(0, 3) + " " + shippingAddressEditCPostal.value.substring(3);
    // Regular expression for Canadian postal code format
    if (!/^[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]\d$/.test(shippingAddressEditCPostal.value)) return false;

    return true;
}

/**
 * 
 * @param {Swiper} swiper 
 * @returns 
 */
function slideChangeTransitionStart(swiper) {
    const previousIdx = swiper.previousIndex;
    const activeIdx = swiper.activeIndex;

    const prevSlide = swiper.slides[previousIdx];
    const prevSlideFamilies = prevSlide.dataset.slide_family?.split(",");

    //If the slide isn't valid for the current type chosen continue to next valid one
    let newIdx = activeIdx;
    let newSlide = swiper.slides[activeIdx];
    let newSlideFamilies = newSlide.dataset.slide_family?.split(",");
    while (!(newIdx == 0 || newIdx == swiper.slides.length - 1 || ((newSlideFamilies?.includes("common") || newSlideFamilies?.includes(returnType)) && slideReasonCheck(newSlide)))) {
        newSlide = swiper.slides[previousIdx > activeIdx ? --newIdx : ++newIdx];
        newSlideFamilies = newSlide.dataset.slide_family?.split(",");
    }
    if (newIdx != activeIdx) {
        swiper.allowSlideNext = true;
        swiper.slideTo(newIdx);
        return;
    }
    const indexes = [previousIdx, newIdx];

    let lowerCutOff;
    let upperCutOff;
    //If the slide it was currently on is wrong then also hide that slide
    if ((!prevSlideFamilies?.includes("common") && !prevSlideFamilies?.includes(returnType)) || !slideReasonCheck(newSlide)) {
        lowerCutOff = Math.min(...indexes);
        upperCutOff = Math.max(...indexes);

        if (previousIdx > activeIdx) {
            lowerCutOff++;
            upperCutOff++;
        }
    }
    else {
        lowerCutOff = Math.min(...indexes) + 1;
        upperCutOff = Math.max(...indexes);
    }

    swiper.slides.slice(lowerCutOff, upperCutOff).forEach(slide => { slide.classList.add("invisible") });
}

/**
 * 
 * @param {Swiper} swiper 
 * @returns 
 */
function slideChange(swiper) {
    //If it took less than 50ms to change the slide after gaining focus than assume that it was the bug changing the slide and change it back
    //I couldn't find a better fix to the slide on focus bug at worst the user is going to have to click twice on something when the click was tabbing in
    if (performance.now() - (timer ?? 0) < 50) {
        timer = 0;
        //Go back to previous slide
        allowNextSlideBtn(true);
        swiper.slideTo(swiper.previousIndex);
        return;
    }
    //By default use next button not send
    returnExchangeWarrantyNextBtn.classList.remove("d-none");
    returnExchangeWarrantySendBtn.classList.add("d-none");

    document.body.scrollIntoView();

    const previousIdx = swiper.previousIndex;
    const activeIdx = swiper.activeIndex;
    const currentSlide = swiper.slides[activeIdx];

    if (swiperNextBtnEl) {
        swiperNextBtnEl.classList.remove("swiperBtn")
        swiperNextBtnEl.onclick = null;
    }

    const crtSlideFamilies = currentSlide.dataset.slide_family?.split(",");
    //If the current slide isn't valid for the current return type don't setup anything because the slide will be skipped over anyways
    if ((!crtSlideFamilies?.includes("common") && !crtSlideFamilies?.includes(returnType)) || !slideReasonCheck(currentSlide)) {
        return;
    }

    if (currentSlide == orderSelectionSlide) {
    }
    if (currentSlide == articleSelectionSlide) {
        //Remove the "wrong" suffix from the return type (it will be added again if they click on the article not here button)
        if (returnType.endsWith("-W")) returnType = returnType.slice(0, -2);
        if (crtSelectedRow) {
            swiperNextBtnEl.classList.add("swiperBtn")
            allowNextSlideBtn(true);
        }
        else {
            swiperNextBtnEl.classList.remove("swiperBtn")
            allowNextSlideBtn(false);
        }
    }
    else if (currentSlide == wrongBootsSizeSelectionSlide) {
        if (checkSrefSelection(wrongBootsSelectedSref1, wrongBootsSelectedSref2, selectedWrongItem)) {
            swiperNextBtnEl.classList.add("swiperBtn")
            allowNextSlideBtn(true);
        }
        else {
            swiperNextBtnEl.classList.remove("swiperBtn")
            allowNextSlideBtn(false);
        }
    }
    else if (currentSlide == wrongBootsShouldReceiveSlide) {
        if (crtSelectedRow) {
            swiperNextBtnEl.classList.add("swiperBtn")
            allowNextSlideBtn(true);
        }
        else {
            swiperNextBtnEl.classList.remove("swiperBtn")
            allowNextSlideBtn(false);
        }
    }
    else if (currentSlide == exchangeSizeSelectionSlide) {
        if (checkSrefSelection(returnOutSelectedSref1, returnOutSelectedSref2, selectedItemOut)) {
            swiperNextBtnEl.classList.add("swiperBtn")
            allowNextSlideBtn(true);
        }
        else {
            setupReturnOut();
        }
    }
    else if (currentSlide == returnQuestionThreeSlide) {
    }
    else if (currentSlide == returnQuestionThreeOtherSlide) {
        if (selectedItemIn != null) fillArticleBox(returnQuestionThreeOtherArticleBox, selectedItemIn);
        swiperNextBtnEl.classList.add("swiperBtn")
        allowNextSlideBtn(true);
    }
    else if (currentSlide == warrantyQuestionOneSlide) {
        if (selectedItemIn != null) fillArticleBox(warrantyQuestionOneArticleBox, selectedItemIn);
        allowNextSlideBtn(false);
    }
    else if (currentSlide == imagesSlide) {
        const computedItemIn = selectedWrongItem ?? selectedItemIn;
        if (computedItemIn != null) fillArticleBox(imageArticleBox, computedItemIn);
        if (returnType == "W") {
            defectDescriptionWrapper.classList.remove("d-none");
            defectDescriptionTitle.innerText = warrantyQuestionOneSlide.querySelector("div[data-type=" + returnReason + "]")?.querySelector(".selectableDivText")?.innerHTML ?? ""
        }
        else {
            defectDescriptionWrapper.classList.add("d-none");
        }

        //if all the images are now filled allow next slide
        const allImagesFilled = imageInputs.every(input =>
            Array.from(input.files ?? []).filter(file => file.type.includes('image')).length != 0
        );

        const applyNextSlideState = (/** @type {Boolean}*/nextSlideAllowed) => {
            allowNextSlideBtn(nextSlideAllowed);
            if (nextSlideAllowed) swiperNextBtnEl.classList.add("swiperBtn");
            else swiperNextBtnEl.classList.remove("swiperBtn");
        };

        //if all images filled we're done; otherwise fall back to the internal-IP check
        if (allImagesFilled) {
            applyNextSlideState(true);
        } else {
            isIpRestricted().then(applyNextSlideState);
        };
    }
    else if (currentSlide == finalCheckSlide) {
        fillFinalCheck();
    }

    //Hide element not from the current type
    if (returnType) {
        (/** @type {NodeListOf<HTMLElement>}*/(currentSlide.querySelectorAll("*[data-types]"))).forEach(child => {
            if (child.dataset.types) {
                if (child.dataset.types.split(",").includes(returnType)) {
                    child.classList.remove("d-none");
                }
                else child.classList.add("d-none");
            }
        });
    }
}

/**
 * 
 * @param {Swiper} swiper 
 */
function slideChangeTransitionEnd(swiper) {
    const previousIdx = swiper.previousIndex;
    const activeIdx = swiper.activeIndex;
    const indexes = [previousIdx, activeIdx];
    const prevSlide = swiper.slides[previousIdx];
    const prevSlideFamilies = prevSlide.dataset.slide_family?.split(",");

    let lowerCutOff;
    let upperCutOff;
    //If the slide it was currently on is wrong then also hide that slide
    if (!prevSlideFamilies?.includes("common") && !prevSlideFamilies?.includes(returnType)) {
        lowerCutOff = Math.min(...indexes);
        upperCutOff = Math.max(...indexes);

        if (previousIdx > activeIdx) {
            lowerCutOff++;
            upperCutOff++;
        }
    }
    else {
        lowerCutOff = Math.min(...indexes) + 1;
        upperCutOff = Math.max(...indexes);
    }

    swiper.slides.slice(lowerCutOff, upperCutOff).forEach(slide => { slide.classList.remove("invisible") });
}

/**
 * 
 * @param {Boolean} allow 
 */
function allowNextSlideBtn(allow) {
    swiperReturn.allowSlideNext = allow;
}

/**
 * 
 * @param {HTMLElement} el 
 * @param {Boolean} smooth 
 */
function scrollToCenterOfEl(el, smooth = true) {
    const rect = el.getBoundingClientRect();
    const top = (rect.top + window.scrollY) - (screen.height / 2) + (rect.height / 2);
    window.scroll({
        top: top,
        behavior: smooth ? 'smooth' : 'instant'
    });
}

/**
 * 
 * @param {string} str 
 * @param {string} substring 
 * @returns 
 */
function splitLastOccurrence(str, substring) {
    const lastIndex = str.lastIndexOf(substring);
    const before = str.slice(0, lastIndex);
    const after = str.slice(lastIndex + 1);
    return [before, after];
}

/**
 * @param {HTMLElement} el
 * @returns {number}
 */
function getIndexOfChild(el) {
    return Array.from(el.parentNode?.children ?? []).indexOf(el);
}

/**
 * Checks if the slide given is valid with the current reasons
 * @param {HTMLElement} slide 
 * @returns 
 */
function slideReasonCheck(slide) {
    if (!slide.dataset.slide_reasons && !slide.dataset.slide_not_reasons) return true;
    let isValid = true;
    if (slide.dataset.slide_reasons) {
        const slideReasons = slide.dataset.slide_reasons.split(",");
        /** @type {Boolean[]} */
        const validationArr = [];
        slideReasons.forEach(reason => {
            const splitReason = reason.split("_");
            const splitReturnReason = returnReason?.split("_");
            if (!returnReason) return false;
            //Check if reason is in it or if there is a wild card if stuff after the wild card is in it
            if (reason !== returnReason && (splitReason.length === 1 || splitReturnReason?.length === 1 || (splitReason[0] === "*" && splitReason[1] !== splitReturnReason?.at(1)))) validationArr.push(false);
            else validationArr.push(true);
        });
        //If none of the possible reasons where valid then it's not valid
        if (!validationArr.some(valid => valid)) isValid = false;
    }
    if (slide.dataset.slide_not_reasons) {
        const slideNotReasons = slide.dataset.slide_not_reasons.split(",");
        slideNotReasons.forEach(reason => {
            const splitReason = reason.split("_");
            const splitReturnReason = returnReason?.split("_");
            //No need to check if there is no return reason
            if (returnReason) {
                //Check if reason is in it or if there is a wild card if stuff after the wild card is in it
                if (reason === returnReason || (splitReason.length !== 1 && splitReturnReason?.length !== 1 && (splitReason[0] === "*" && splitReason[1] === splitReturnReason?.at(1)))) isValid = false;
            }
        });
    }
    return isValid;
}

/**
 * 
 * @param {Date} date 
 * @returns 
 */
function formatDate(date) { return new Date(date.getTime() - (date.getTimezoneOffset() * 60 * 1000)).toISOString().split('T')[0]; }